import type { FC } from 'react';
import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic';
import { CategoryTiles } from './CategoryTiles';
import { HtmlSnippet } from './HtmlSnippet';

export type Category = ShopperProductsTypes.Category & {
    c_productInfoTile?: string[];
    c_template?: string;
    c_href: string;
    c_slotBannerImage: string;
};

export interface IBlock {
    type: 'html' | 'category';
    id: string;
    component: string;
    calloutMsg?: string;
}

export interface HtmlBlock extends IBlock {
    type: 'html';
    component: 'HTML_SNIPPET';
    calloutMsg?: string;
    html: string;
}

export interface HtmlSlot {
    html: string;
}

export interface ContentAsset {
    id: string;
    html: string;
}

export interface CategoryBlock extends IBlock {
    type: 'category';
    component: 'CATEGORY_BUTTON_TILES' | 'CATEGORY_IMAGE_TILES';
    calloutMsg?: string;
    items: Category[];
}

export type Block = HtmlBlock | CategoryBlock;

export interface BlocksProps {
    id: string;
    contentBlocks?: Record<string, Block[]>;
    className?: string;
}

/**
 * This component is used to render a list of blocks.
 *
 * @param blocks - The list of blocks to render.
 * @returns A list of blocks.
 */
const Blocks: FC<BlocksProps> = ({ id, contentBlocks: slots, className }) => {
    const blocks = slots?.[id] ?? [];
    return (
        <>
            {blocks.map((block) => {
                if (block.type === 'html') {
                    return (
                        <HtmlSnippet
                            key={block.id}
                            id={id}
                            html={block.html}
                            className={className}
                        />
                    );
                }

                if (block.type === 'category') {
                    return (
                        <CategoryTiles
                            key={block.id}
                            dataTestId={id}
                            items={block.items}
                            component={block.component}
                        />
                    );
                }

                return null;
            })}
        </>
    );
};

Blocks.defaultProps = {
    contentBlocks: {},
    className: '',
};

export { Blocks };
